module.exports = __webpack_public_path__ + "img/tab-02.52cae644.png";